<template>
  <div class="no-footer-pop-content w600">
    <div class="pop-form-wrap">
      <el-tree :data="moduleData" :props="moduleProp" ref="powerTree" empty-text="Loading.." show-checkbox node-key="MoCode" :expand-on-click-node="false" :default-expand-all="true" @check-change="checkPowerTreeChange"></el-tree>
    </div>
    <div class="dialog-footer pop-center-btn-wrap">
      <el-button type="primary" @click="doConfirm">Confirm</el-button>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import _ from 'underscore'

import tools from '@/components/common/tools'
import tree from '@/components/common/tree'

// 菜单树
let moduleTree = new tree.TreeCreate(function(item) {
  for (let key in item) {
    if (item.hasOwnProperty(key)) {
      this[key] = item[key]
    }
  }
}, { FId: 'MoFacode', Id: 'MoCode' })

// 请求相关操作
let page = {
  methods: {
    // 获得指定部门权限
    getDepartmentPowerDataAjax(hasLoading) {
      return tools.commonAjax.call(this, hasLoading, '/SystemManage/GetAdminUserModuleFromOgCode', {
        code: this.currentCode
      })
    },
    // 获得指定用户权限
    getUserPowerDataAjax(hasLoading) {
      return tools.commonAjax.call(this, hasLoading, '/SystemManage/GetAdminUserModule', {
        code: this.currentCode
      })
    },
    // 获得指定角色权限
    getLabelPowerDataAjax(hasLoading) {
      return tools.commonAjax.call(this, hasLoading, '/SystemManage/GetAdminUserModuleFromLbCode', {
        code: this.currentCode
      })
    },
    // 获取菜单列表操作
    getModuleListDataAjax() {
      return tools.commonAjax.call(this, false, '/SystemManage/GetModuleList', {
        All: 1
      }).then((res) => {
        let result = res.data
        moduleTree.create(result)
        this.moduleData = moduleTree.getTreeData()
      })
    },
    // add权限操作
    updatePowerDataAjax() {
      let data = tools.getModel(this.submitData)
      data = data.map(item => {
        return {
          MoCode: item.MoCode,
          ReType: this.currentType,
          ReCode: this.currentCode
        }
      })
      return tools.commonAjax.call(this, true, '/SystemManage/AddModuleRelationAdmin', $.extend({
        code: this.currentCode
      }, tools.mvcParamMatch(data, 'modellist'))).then(() => {
        this.$message.success('修改成功!')
        // if (this.currentType === this.PowerTypeConfig.STAFF) {
        //   // 如果是[员工],且修改为当前用户 -> 重新获取用户信息
        //   if (this.currentCode === this.$store.state.user.memberInfo.AuCode) {
        //     this.$store.dispatch('getLoginMemberInfo', false)
        //   }
        // }
        // 因为无法得知是否修改的为当前用户的部门或关联的角色的权限, 所以修改成功后都重新获取用户信息
        this.$store.dispatch('getLoginMemberInfo', false)
        this.$emit('updatePowerSuccess')
      })
    }
  }
}

export default {
  name: 'PowerForm',
  componentName: 'PowerForm',
  mixins: [page],
  // props: [
  //   'currentType', // 关联类型 0[部门] 1[员工] 2[角色]
  //   'currentCode' // currentType 对应类型的 [部门][员工][角色] 的 code
  // ],
  created() {
    // 获取菜单列表操作
    this.getModuleListDataAjax()
  },
  data() {
    return {
      // 权限类型配置项
      PowerTypeConfig: {
        // 部门
        DEPARTMENT: 0,
        // 员工
        STAFF: 1,
        // 角色(标签)
        LABEL: 2
      },
      // 权限菜单树数据
      moduleData: [],
      // 权限菜单树配置项
      moduleProp: {
        label: 'MoName',
        children: 'children'
      },
      // 关联类型 0[部门] 1[员工] 2[角色]
      currentType: null,
      // currentType 对应类型的 [部门][员工][角色] 的 code
      currentCode: null,
      // 提交的数据
      submitData: []
    }
  },
  methods: {
    // ConfirmGive permission
    doConfirm() {
      this.updatePowerDataAjax()
    },
    // 权限树选中状态变化
    checkPowerTreeChange(item, isSelect) {
      if (isSelect) {
        this.submitData.push(tools.getModel(item))
      } else {
        var idx = _.findIndex(this.submitData, function(el) {
          return el.MoCode === item.MoCode
        })
        if (idx !== -1) {
          this.submitData.splice(idx, 1)
        }
      }
    },
    // 获取默认数据
    getDefaultData(currentType, currentCode, hasLoading = true) {
      this.currentType = currentType
      this.currentCode = currentCode
      let def
      if (currentType === this.PowerTypeConfig.DEPARTMENT) {
        // 获得指定部门权限
        def = this.getDepartmentPowerDataAjax(hasLoading)
      } else if (currentType === this.PowerTypeConfig.STAFF) {
        // 获得指定用户权限
        def = this.getUserPowerDataAjax(hasLoading)
      } else if (currentType === this.PowerTypeConfig.LABEL) {
        // 获得指定角色权限
        def = this.getLabelPowerDataAjax(hasLoading)
      }
      def.then(res => {
        let result = res.data
        this.$refs.powerTree.setCheckedKeys(result.map(function(item) {
          return item.MoCode
        }))
      })
      return def
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/lib-config";
</style>




// WEBPACK FOOTER //
// PowerForm.vue?0a1e4fac